import { Fragment } from "react/jsx-runtime";
import { ScoreRating } from "~/operations";
import { Grid, TableRow } from "@mui/material";
import {
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { ReportsNoItemsSection } from "../../components";
import { useAssetReport } from "../hooks/useAssetReport";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

export function AssetReportVulnerabilities() {
  const { vulnerabilities } = useAssetReport();
  const hasVulnerabilities = Boolean(vulnerabilities?.length);

  return (
    <Fragment>
      <ReportsSectionHeading heading="Vulnerabilities" disableUpperPadding />
      <Grid size={12} sx={{ my: 3 }}>
        {!hasVulnerabilities ? (
          <ReportsNoItemsSection target="vulnerabilities" />
        ) : (
          <GenericTable
            space={undefined}
            items={0}
            tableName="ASSET_REPORT_VULNERABILITIES"
            validSortFields={[]}
            printView
          >
            {vulnerabilities?.map((vulnerability) => {
              return (
                <TableRow key={vulnerability?.id}>
                  <ImpactCell
                    impact={vulnerability?.riskValue || 0}
                    rating={vulnerability?.rating || ScoreRating.Critical}
                    isActive
                  />
                  <TitleCell
                    title={vulnerability?.id || ""}
                    tags={vulnerability?.tags}
                    options={{ fontSize: 14 }}
                  />
                  <RiskFactorsCell
                    riskFactors={vulnerability?.riskFactors}
                    printView
                  />
                  <PublishedCell
                    date={vulnerability?.lastUpdated || "Never"}
                    formatting="absolute"
                  />
                </TableRow>
              );
            })}
          </GenericTable>
        )}
      </Grid>
    </Fragment>
  );
}
